import './pixi/utils/pixiDestroyLeakFixes';

// Dynamic loading based on Electron mode
// More robust Electron detection
const isElectronEnvironment = !!(
  window.ipcRenderer
);

if(isElectronEnvironment){
  window.isElectron = true;
  console.log('Loading Electron (main) version');
  import('./indexMain.js');
} else {
  window.isElectron = false;
  console.log('Loading Web version');
  import('./indexWeb.js');
}

